// Autogenerated file
export const distributionBidStatusesEnum = {
    New: "New",
    InProcess: "InProcess",
    Canceled: "Canceled",
};
export const distributionBidStatuses = [
    { label: "Новый", value: "New" },
    { label: "Заполняется", value: "InProcess" },
    { label: "Отменен", value: "Canceled" },
];
